/**
 * Static prompt copy for marketing. Sync from DB when needed.
 * (Example batch from prompts id 40–100.)
 */
export const PROMPTS: string[] = [
  "a photo from the gc",
  "random meme",
  "the classic sidepart",
  "your friend in their shift",
  "a jumpscare",
  "sniped",
  "0.5",
  "photo during in covid",
  "outfit check",
  "do not kill yourself pic",
  "makes you go \u{1F62D}\u{1F62D}\u{1F62D}",
  "want to speak to your manager type photo",
  "looks like a cinnamon could kill you",
  "\u{1F494}\u{1F494}\u{1F940}\u{1F940}\u{1F940}",
  "your first recent photo in your camera roll",
  "emo photo",
  "profile pic idea",
  "an old photo of you",
  "mirror selfie",
  "photo from a last sleep over",
  "a picture of something your proud of",
  "just woke up photo",
  "main character energy",
  "so chopped",
  "Just a casual photo dump",
  "socrates, plato, aristotle",
  "brain rot",
  "pictures of hte night sky",
  "facebook mom photos",
  "stalk photos",
  "bad parking",
  "gluttony",
  "grocery haul",
  "times you look like frank gallagher",
  "greatest achievement",
  "drafted instagram photos",
  "cs majors",
  "best halloween custome",
  "what rock bottom looks like",
  "album cover",
  "niche",
  "screenshot of texts",
  "flower photos",
  "concert photos",
  "A really cool hat",
  "the american dream",
  "a canadian",
  "photos of drinks",
  "messy room",
  "dying laughing photo",
  "I guess bro",
  "2 sticks of RAM cost $900 because of ts btw",
  "\u{1F602}\u{1F602}\u{1F602}",
  "stay in school or this could be you",
  "photo with of you with a celebrity",
  "new haircut",
  "the big leagues",
  "vacation photos",
  "beach photos",
  "scuba diving",
  "LARP alert",
];

/**
 * Prompt line for each image in `/public/prompt-examples`, in file order (gc → … → instagram-draft).
 * Each string must appear in `PROMPTS`. Used by the marketing photo stack.
 */
export const PROMPT_EXAMPLE_IMAGE_LABELS = [
  "a photo from the gc",
  "photo during in covid",
  "your first recent photo in your camera roll",
  "just woke up photo",
  "flower photos",
  "drafted instagram photos",
] as const;
